import { gql } from '@apollo/client'
import { useTranslations } from '@npco/utils-translations'
import {
  Box,
  COLOR,
  Flex,
  Tutorial,
  Typography,
  useIsMobileResolution,
} from '@npco/zeller-design-system'
import { ScrollableContentWithNewBadge } from 'features/StartupModals/common/components/ScrollableContentWithNewBadge/ScrollableContentWithNewBadge'

import { Subtitle } from '../../../SetupFlow/SetupFlowModal/SetupFlowModal.styled'
import { ModalContentEntitySavingsAccountProductFragment } from './ModalContent.generated'
import { modalContentTranslations } from './ModalContent.i18n'

type ModalContentProps = {
  entitySavingsAccountProduct: ModalContentEntitySavingsAccountProductFragment
  isSavingsAccountActivated: boolean
}

export const ModalContent = ({
  entitySavingsAccountProduct,
  isSavingsAccountActivated,
}: ModalContentProps) => {
  const t = useTranslations(modalContentTranslations)
  const isMobile = useIsMobileResolution()

  return (
    <ScrollableContentWithNewBadge text={t('badge')}>
      <Typography variant="heading-2xl">
        {t('title', {
          baseInterestRate: entitySavingsAccountProduct.baseInterestRate,
        })}
      </Typography>
      <Subtitle>
        {t('description', {
          termsApply: isMobile && (
            <Typography variant="body-sm" color={COLOR.GREY_550}>
              {t('termsApply')}
            </Typography>
          ),
        })}
      </Subtitle>

      {!isMobile && (
        <Flex flexDirection="column" gap="4px" lineHeight="24px">
          <Tutorial.BulletPoint
            iconColour={COLOR.GREEN_1000}
            text={
              isSavingsAccountActivated
                ? t('point1ForActivatedSavings')
                : t('point1ForNotActivatedSavings')
            }
          />
          <Tutorial.BulletPoint
            iconColour={COLOR.GREEN_1000}
            text={t('point2')}
          />
          <Tutorial.BulletPoint
            iconColour={COLOR.GREEN_1000}
            text={t('point3')}
          />
          <Tutorial.BulletPoint
            iconColour={COLOR.GREEN_1000}
            text={t('point4')}
          />
        </Flex>
      )}
      <Box backgroundColor="#EAFFB5" p="12px 16px 16px 16px" borderRadius="8px">
        <Typography variant="heading-md" color={COLOR.DARK_BLUE}>
          {t('offerHeading')}
        </Typography>
        {!isMobile && (
          <Typography variant="body-sm" color={COLOR.DARK_BLUE}>
            {t('offerDescription')}
          </Typography>
        )}
      </Box>
    </ScrollableContentWithNewBadge>
  )
}

ModalContent.fragments = {
  EntitySavingsAccountProduct: gql`
    fragment ModalContentEntitySavingsAccountProductFragment on EntitySavingsAccountProduct {
      baseInterestRate
    }
  `,
}
